<template>
  <!--
    作者：kmdshop
    时间：2020-06-25
    描述：插件中心-限时秒杀-秒杀活动-基础设置
  -->
  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item label="商家名称" prop="name" :rules="[{ required: true, message: '请输入商家名称', trigger: 'blur' }]">
      <el-input v-model="form.name" placeholder="请输入商家名称" class="max-w460"></el-input>
    </el-form-item>
     <el-form-item label="商家等级">
        <el-select v-model="form.kmd_grade_id" placeholder="-请选择等级-">
           <el-option v-for="item in gradeList" :value="item.kmd_grade_id" :key="item.kmd_grade_id" :label="item.name" ></el-option>
        </el-select>
      </el-form-item>
    <el-form-item label="商家logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.image_id!=''" class="img">
            <img :src="form.file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      
      <el-form-item label="详细地址" prop="address">
        <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
          </el-col>
        </el-row>

      </el-form-item>

      <el-form-item label="禁止下单购买" prop="is_forbidden_buy" >
         <el-radio-group v-model="form.is_forbidden_buy">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="禁止下单购买提示图片" prop="wxqrcode" v-if="form.is_forbidden_buy==1" >
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUploads({'type':'erweima'})">选择图片</el-button>
          <div v-if="form.wxqrcode!=''"  class="img pr">
            <img :src="form.wxqrcode" width="100" height="100" />
             <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('wxqrcode')"><i class="el-icon-close"></i></a>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="视频封面图" prop="poster" >
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUploads({'type':'poster'})">选择图片</el-button>
          <div v-if="form.poster!=''" class="img pr">
            <img :src="form.poster" width="100" height="100" />
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('poster')"><i class="el-icon-close"></i></a>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="视频" prop="video" >
 
          <el-input type="text"  v-model="form.video"  placeholder="请选择视频" class="max-w460">
            <template slot="append">
             <el-button icon="el-icon-picture-outline" @click="openUploads({'type':'video'})">选择视频</el-button>
            </template>
          </el-input>
      </el-form-item>

      <el-form-item label="商家简介">
        <el-input type="textarea" v-model="form.introduce" placeholder="请输入简介" class="max-w460"></el-input>
      </el-form-item>
       <el-form-item label="备注">
        <el-input type="textarea" v-model="form.remark" placeholder="请输入备注" class="max-w460"></el-input>
      </el-form-item>
      <!-- 20201201供应商商品展示模式 -->
      <el-form-item label="商品展示">
        <el-radio-group v-model="form.product_show">
            <el-radio :label="'one_column'">单列</el-radio>
            <el-radio :label="'two_column'">两列</el-radio>
            <el-radio :label="'video_scale'">16:9</el-radio>
        </el-radio-group>
      </el-form-item>

    <div class="common-form">登陆信息</div>
     <el-form-item label="绑定用户">
          <div class="d-s-s d-c">
            <el-button @click="openGetuser"  icon="el-icon-plus">选择会员</el-button>
            <div class="d-s-s" v-if="form.user">
                <img :src="form.user.avatarUrl" class="radius" width="30" height="30" />
            </div>
            <div class="d-s-s" v-if="form.user">
                 <p class="lh18 ww100 text-ellipsis">用户昵称：{{form.user.nickName}}</p>
               
            </div>
            <div class="d-s-s"  v-if="form.user">
                <p class="lh18 ww100 text-ellipsis">手机号：{{form.user.mobile}}</p>
            </div>
          </div>
          <span>绑懂定用户用于移动端管理</span>
        </el-form-item>
    <el-form-item label="后台账号" prop="user_name" :rules="[{required: true,message: ' '}]">
        <el-input type='mobile' v-model="form.user_name" v-if="!is_edit" placeholder="请输入手机号" class="max-w460"></el-input>
        <el-input type='mobile' v-model="form.user_name" v-if="is_edit" readonly placeholder="请输入手机号" class="max-w460"></el-input>
        @{{app_id}}
      </el-form-item>
      <el-form-item label="后台密码" prop="password" >
        <el-input v-model="form.password" placeholder="请输入密码" class="max-w460"></el-input>
      </el-form-item>
     
       <el-form-item label="商家状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商家类型">
        <el-radio-group v-model="form.self_manage">
          <el-radio :label="1">自营</el-radio>
          <el-radio :label="0">非自营</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序">
        <el-input type="number" v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>

     <!--上传图片组件-->
    <Upload v-if="uploadtype=='erweima'" :isupload="isOtherUpload" type="image" @returnImgs="returnErweimaFunc">上传二维码</Upload>
    <!--上传图片组件-->
    <Upload v-if="uploadtype=='poster'" :isupload="isOtherUpload" type="image" @returnImgs="returnPosterFunc">上传视频封面</Upload>

    <!--上传视频组件-->
    <Upload v-if="uploadtype=='video'" :isupload="isOtherUpload" type="video" @returnImgs="returnVideosFunc">上传视频</Upload>
    <!--选择用户-->
    <GetUser :is_open="open_getuser" @close="closeGetuserFunc"></GetUser>
  </div>
</template>

<script>
import Getpoint from '@/components/map/Getpoint.vue';
import Upload from '@/components/file/Upload';
import GetUser from '@/components/user/GetUser.vue';
export default {
  components: {
    /*选择商品组件*/
    Upload,
    Getpoint,
    GetUser
  },
  data() {
     

    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) =>{
    	if(value<1){
    		return callback(new Error('请上传活动图'));
    	}else{
         callback();
    	}
    };

    return {
      /*获取用户是否显示*/
      open_getuser: false,
      /*选择的用户列表*/
      select_user:{},
      /* 上传类型 */
      uploadtype:'',
      /* 是否打开其他上传 */
      isOtherUpload:false,
       /*是否打开添加弹窗*/
      open_add: false,
      /*是否上传图片*/
      isupload: false,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传logo', trigger: 'change' }]
    };
  },
  props: {
    form: Object,
    gradeList:Array,
    app_id:Number,
    is_edit:Boolean
  },
  methods: {
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },


     /*获取经纬度*/
      getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;

      },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.file_path = e[0].file_path;
        this.form.image_id = e[0].file_id;
      }
      this.isupload = false;
    },
    /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },
    /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_add = false;
      },
      /* 打开上传 */
      openUploads(e) {
        this.uploadtype = e.type;
        this.isOtherUpload  = true;

      },
      /* 获取二维码 */
      returnErweimaFunc(e){
        if (e != null && e.length > 0) {
          this.form.wxqrcode = e[0].file_path;
        }
        this.isOtherUpload = false;
        this.uploadtype = '';
      },
      /* 获取视频封面 */
      returnPosterFunc(e) {

        if (e != null && e.length > 0) {
          this.form.poster = e[0].file_path;
        }
        this.isOtherUpload = false;
        this.uploadtype = '';
      },
      /* 获取视频 */
      returnVideosFunc(e) {

        if (e != null && e.length > 0) {
          this.form.video = e[0].file_path;
        }
        this.isOtherUpload = false;
        this.uploadtype = '';
      },
      /* 删除图片 */
      deleteImg(type){
        if(type=='poster'){
          this.form.poster='';
        }
        if(type=='wxqrcode'){
          this.form.wxqrcode='';
        }
      },
      /*打开获取用户*/
    openGetuser() {
      this.open_getuser = true;
    },

    /*关闭获取用户*/
    closeGetuserFunc(e) {
      if (e.type != 'error') {
        this.form.user=e.params[0];
        this.form.user_id=e.params[0].user_id;
      }
      this.open_getuser = false;
    },
      
  }
};
</script>

<style lang="scss" scoped="scoped">
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}
.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/supply/part/Basic.vue